import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
/**
 * Format cents as euros (Dutch notation)
 * @param cents - Amount in cents (e.g., 9500 = €95.00)
 * @returns Formatted string (e.g., "€ 95,00")
 */
export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
  }).format(cents / 100);
}

/**
 * Convert euros (string or number) to cents
 * @param euros - Amount in euros (e.g., "95.00" or 95)
 * @returns Amount in cents (e.g., 9500)
 */
export function eurosToCents(euros: string | number): number {
  const num = typeof euros === "string" ? parseFloat(euros) : euros;
  return Math.round(num * 100);
}
